import { useEffect, useState } from 'react';
import Logger from '@/lib/logger';
import getCityCuisines, { type CityCuisine } from './getCityCuisines';

const logger = new Logger('CITY_CUISINES', 'ERROR');

export default function usePD6630Cuisines(cityId?: number) {
  const [cuisines, setCuisines] = useState<CityCuisine[]>([]);
  const [isLoading, setIsLoading] = useState(() => cityId != null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (cityId == null) {
      setCuisines([]);
      setIsLoading(false);
      setHasError(false);
      return undefined;
    }

    const abortController = new AbortController();
    const { signal } = abortController;

    setIsLoading(true);
    setHasError(false);

    (async () => {
      try {
        const results = await getCityCuisines({ cityId, abortSignal: signal });
        if (signal.aborted) return;
        setCuisines(results);
      } catch (error) {
        if (signal.aborted) return;
        setCuisines([]);
        setHasError(true);
        logger.error('Failed to fetch city cuisines', error);
      } finally {
        if (!signal.aborted) setIsLoading(false);
      }
    })();

    return () => {
      abortController.abort();
    };
  }, [cityId]);

  return { cuisines, isLoading, hasError };
}
